module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "vm-message-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "vm-message",
    class: _vm.customClass,
    on: {
      "mouseenter": _vm.clearTimer,
      "mouseleave": _vm.startTimer
    }
  }, [_c('div', {
    staticClass: "vm-message__group"
  }, [_c('p', {
    staticClass: "vm-message__inner"
  }, [_c('i', {
    staticClass: "vm-message__icon",
    class: [_vm.iconClass ? _vm.iconClass : 'vm-message-icon--' + _vm.type]
  }), _vm._t("default", [_vm._v(_vm._s(_vm.message))])], 2), _vm._v(" "), (_vm.showClose) ? _c('div', {
    staticClass: "vm-message__close vm-message-icon--close",
    on: {
      "click": _vm.close
    }
  }) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-e6c2c0a2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-e6c2c0a2","hasScoped":false}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/message.vue
// module id = 11
// module chunks = 0